<template>
  <div class="overlay">
    <div class="overlay-content border rounded d-flex flex-column justify-content-around">
      <BlueLoader />
      <h4><strong>Processing Payment...</strong></h4>
    </div>
  </div>
</template>

<script setup>
import BlueLoader from '@/components/ux/BlueLoader.vue';
</script>

<style scoped>
.overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 2;
  background-color: #f2f1f1a1;
}
.overlay-content {
  background-color: white;
  margin: -10% auto;
  padding: 24px;
  width: 20%;
  height: 20%;
  box-shadow: 0 0 10px gray;
  position: absolute;
  transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
  top: 50%;
  left: 0;
  right: 0;
  text-align: center;
}

@media (max-width: 850px) {
  .overlay-content {
    width: 50% !important;
  }
}
</style>
